import api from '.'

export const automaticQueries = {
  create (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/automatic-queries`, data, success, fail)
  },
  getForTrial (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/automatic-queries`, null, success, fail)
  },
  update (automaticQueryId, data, success, fail) {
    api.authenticatedRequest('PUT', `/automatic-queries/${automaticQueryId}`, data, success, fail)
  },
  delete (automaticQueryId, success, fail) {
    api.authenticatedRequest('DELETE', `/automatic-queries/${automaticQueryId}`, null, success, fail)
  }
}
